import { render } from "./ChamadosAndamentoView.vue?vue&type=template&id=536ee4ca&scoped=true"
import script from "./ChamadosAndamentoView.vue?vue&type=script&lang=js"
export * from "./ChamadosAndamentoView.vue?vue&type=script&lang=js"

import "./ChamadosAndamentoView.vue?vue&type=style&index=0&id=536ee4ca&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536ee4ca"]])

export default __exports__